// extracted by mini-css-extract-plugin
export default {"diffText":"diffText_DiffIndicator-module_vKlBS"};